import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppConfigService {
  containerDownloadUrl: string;
  powerBiHostname: string;
  tenant: string;
  clientId: string;
  reportId: string;
  groupId: string;

  backendUrl: string;
  storageAccountUrl: string;

  coilCadeUrl: string;
  coilScanReportId: string;

  constructor(private http: HttpClient) { }
  load() {
    return this.http.get('assets/config.json').toPromise()
      .then((response: any) => {
        for (let property of ['containerDownloadUrl',
                              'powerBiHostname',
                              'tenant',
                              'clientId',
                              'reportId',
                              'groupId',
                              'backendUrl',
                              'storageAccountUrl',
                              'coilCadeUrl',
                              'coilScanReportId']) {
          this[property] = response[property];
        }
      });
  }
}
